import styled from 'styled-components';

import { SummaryAttachment } from './types';

type Props = {
  attachment: SummaryAttachment;
  size?: number;
};

export default function CitationBadge({ attachment, size = 16 }: Props) {
  return (
    <StyledBadge size={size} title={attachment.filename}>
      {attachment.displayId}
    </StyledBadge>
  );
}

const StyledBadge = styled.span<{ size: number }>`
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 26px;
  background: rgba(94, 66, 225, 0.2);
  color: #3e2d6e;
  line-height: 8px;
  font-size: 8px;
  font-weight: 700;
  cursor: default;
`;
